import Dashboard from "views/Dashboard/Dashboard.jsx";
import Buttons from "views/Components/Buttons.jsx";
import GridSystem from "views/Components/GridSystem.jsx";
import Panels from "views/Components/Panels.jsx";
import SweetAlert from "views/Components/SweetAlert.jsx";
import Notifications from "views/Components/Notifications.jsx";
import Icons from "views/Components/Icons.jsx";
import Typography from "views/Components/Typography.jsx";
import RegularForms from "views/Forms/RegularForms.jsx";
import ExtendedForms from "views/Forms/ExtendedForms.jsx";
import ValidationForms from "views/Forms/ValidationForms.jsx";
import Wizard from "views/Forms/Wizard.jsx";
import RegularTables from "views/Tables/RegularTables.jsx";
import ExtendedTables from "views/Tables/ExtendedTables.jsx";
import ReactTables from "views/Tables/ReactTables.jsx";
// import GoogleMaps from "views/Maps/GoogleMaps.jsx";
// import FullScreenMap from "views/Maps/FullScreenMap.jsx";
// import VectorMap from "views/Maps/VectorMap.jsx";
import ViewProfile from "views/Profile/viewProfile.jsx";
import GroupIcon from "@material-ui/icons/Group";
import Charts from "views/Charts/Charts.jsx";
import Calendar from "views/Calendar/Calendar.jsx";
// import Widgets from "views/Widgets/Widgets.jsx";
import UserProfile from "views/Pages/UserProfile.jsx";
import TimelinePage from "views/Pages/Timeline.jsx";
import RTLSupport from "views/Pages/RTLSupport.jsx";
import ClinicMaster from "views/ClinicMasters/ClinicMasters.jsx";
import addClinicMaster from "views/ClinicMasters/addClinicMaster.jsx";
import oneClinicMaster from "views/ClinicMasters/oneClinicMaster.jsx";
import updateClinicMaster from "views/ClinicMasters/updateClinicMaster.jsx";
import Clinic from "views/Clinics/Clinics.jsx";
import addClinic from "views/Clinics/addClinic.jsx";
import updateClinic from "views/Clinics/updateClinic.jsx";
import oneClinic from "views/Clinics/oneClinic.jsx";
import ClinicRoles from "views/Roles/Clinic/ClinicRolesList.jsx";
import ClinicRoleView from "views/Roles/Clinic/ClinicRoleView.jsx";
import UserRoles from "views/Roles/User/UserRolesList.jsx";
import UserRoleAdd from "views/Roles/User/UserRoleAdd.jsx";
import UserRoleView from "views/Roles/User/UserRoleView.jsx";
import UserRoleUpdate from "views/Roles/User/UserRoleUpdate.jsx";
import ClinicRoleAdd from "views/Roles/Clinic/ClinicRoleAdd.jsx";
import ClinicRoleUpdate from "views/Roles/Clinic/ClinicRoleUpdate.jsx";
import Doctor from "views/Doctors/Doctors.jsx";
//import Patients from "views/Patients/Patients.jsx";
import oneDoctor from "views/Doctors/oneDoctor.jsx";
import addDoctor from "views/Doctors/addDoctor.jsx";
import updateDoctorTS from "views/Doctors/updateDoctorTS.jsx";
import updateDoctorDetails from "views/Doctors/updateDoctorDetails.jsx";
import Patient from "views/Patients/Patients.jsx";
import onePatient from "views/Patients/onePatient.jsx";
import updatePatient from "views/Patients/updatePatientTS.jsx";
import addPatient from "views/Patients/addPatient.jsx";
import Reports from "views/Reports/Reports.jsx";
import AddReports from "views/Reports/AddReports.jsx";
import AddReportsDrag from "views/Reports/AddReportsDrag.jsx";
import UpdateReports from "views/Reports/UpdateReports.jsx";
import OneReport from "views/Reports/oneReport.jsx";
import BookAppointment from "views/Appointments/Book.jsx";
import Appointments from "views/Appointments/Appointments.jsx";
import OneAppointment from "views/Appointments/oneAppointment.jsx";
import OneAppointmentRequest from "views/Appointments/oneAppointmentRequest.jsx";
import AppointmentRequests from "views/Appointments/appointmentRequests.jsx";
import Campaign from "views/Marketing/Campaign.jsx";
import CampaignList from "views/Marketing/CampaignsList.jsx";
import JDLeadsList from "views/Marketing/JDLeadsList.jsx";
import AppointmentCalendar from "views/Appointments/appointmentCalendar.jsx";
import ReportsBatchDrag from "views/Reports/ReportsBatchDrag.jsx";
import BatchReports from "views/Reports/BatchReports.jsx";
import OneTestRequest from "views/Tests/oneTestRequest.jsx";
import RequestsTest from "views/Tests/testRequests.jsx";
import PackagesRequests from "views/Packages/packagesRequests.jsx";
import OnePackageRequest from "views/Packages/onePackageRequest.jsx";
import pagesRoutes from "./pages.jsx";
import UpdateAppointment from "views/Appointments/updateAppointment.jsx";
import CampaignsList from "views/Marketing/CampaignsList.jsx";
import ReCampaign from "views/Marketing/RerunCampaign.jsx";
import Support from "views/Support/index.jsx";

// @material-ui/icons
import DashboardIcon from "@material-ui/icons/Dashboard";
import Image from "@material-ui/icons/Image";
import Apps from "@material-ui/icons/Apps";
// import ContentPaste from "@material-ui/icons/ContentPaste";
import GridOn from "@material-ui/icons/GridOn";
import Place from "@material-ui/icons/Place";
import Business from "@material-ui/icons/Business";
import Hospital from "@material-ui/icons/LocalHospital";
import Person from "@material-ui/icons/Person";
import WidgetsIcon from "@material-ui/icons/Widgets";
import Timeline from "@material-ui/icons/Timeline";
import DateRange from "@material-ui/icons/DateRange";
import Assignment from "@material-ui/icons/Assignment";
// import FileUpload from "@material-ui/icons/FileUpload";
import {mappingUI, isHealthSpaceUser} from '../util/globalHelper';
import Permissions from '../util/globalPermissions';

var newDashRoutes = [
    {
        path: "/newdash/dashboard",
        name: "Dashboard",
        icon: DashboardIcon,
        component: Dashboard
    },
    // {
    //   path: "/newdash/clinicmasters",
    //   name: "ClinicMasters",
    //   icon: Business,
    //   component: ClinicMaster,
    // },
    mappingUI(Permissions.ViewClinics) ?
        {
            path: "/newdash/clinic/readClinics",
            name: "Clinics",
            icon: Business,
            component: Clinic
        }
        : null
    ,
    mappingUI(Permissions.ViewDoctors) ?
        {
            path: "/newdash/doctor/readDoctors",
            name: "Doctors",
            icon: Hospital,
            component: Doctor
        }
        : null
    ,
    mappingUI(Permissions.ViewPatients) ?
        {
            path: "/newdash/patient/readPatients",
            name: "Patients",
            icon: Person,
            component: Patient
        } : null,
    mappingUI(Permissions.ViewReports) ?
        {
            path: "/newdash/report/readReports",
            name: "Reports",
            icon: Assignment,
            component: Reports,
        } : null,
    mappingUI(Permissions.UploadReports) ?
        {
            path: "/newdash/report/adddrag",
            name: "Add Report",
            icon: Assignment,
            component: AddReportsDrag,
        } : null,
    mappingUI(Permissions.ViewAppointments) ?
        {
            collapse: true,
            path: "/newdash/appointment/readAppointments",
            name: "Appointments",
            state: "openAppointments",
            icon: DateRange,
            views: [
                {
                    path: "/newdash/appointment/readAppointments",
                    name: "View Appointments",
                    mini: "VA",
                    component: Appointments
                },
                {
                    path: "/newdash/appointment/calendar",
                    name: "Appointment Calendar",
                    icon: WidgetsIcon,
                    mini: "AC",
                    component: AppointmentCalendar,
                },
                {
                    path: "/newdash/appointment/requests",
                    name: `Appointment Requests (${localStorage.getItem("requestList") ? JSON.parse(localStorage.getItem("requestList")).length : 0})`,
                    mini: "AR",
                    component: AppointmentRequests,
                }
            ]
        } : null,
    isHealthSpaceUser() ? {
        collapse: true,
        path: "/newdash/packages",
        name: "Packages",
        state: "openPackages",
        icon: GridOn,
        views: [
            {
                path: "/newdash/packages/requests",
                name: `Packages Requests`,
                mini: "PR",
                component: PackagesRequests,
            },
        ]
    } : null,

    isHealthSpaceUser() ? {
        collapse: true,
        path: "/newdash/tests",
        name: "Tests",
        state: "openTests",
        icon: GridOn,
        views: [
            {
                path: "/newdash/tests/request",
                name: "Test Request",
                mini: "AT",
                component: RequestsTest
            }
        ]
    } : null,
    isHealthSpaceUser() ? {
        collapse: true,
        path: "/newdash/marketing",
        name: "Marketing",
        state: "openMarketing",
        icon: GridOn,
        views: [
            {
                path: "/newdash/marketing/jdleads",
                name: "Just Dial Leads",
                mini: "JDL",
                component: JDLeadsList
            },
            {
                path: "/newdash/marketing/list",
                name: "Campaigns",
                mini: "MC",
                component: CampaignList
            },
            {
                path: "/newdash/marketing/campaign",
                name: "New Campaign",
                mini: "MC",
                component: Campaign
            }
        ]
    } : null,
    
    {
        path: "/newdash/report/batchupload",
        name: "Upload Batch Reports",
        icon: Assignment,
        component: ReportsBatchDrag,
    }, {
        path: "/newdash/report/getbatchfiles",
        name: "View Batch Reports",
        icon: Assignment,
        component: BatchReports,
    },
    {
        collapse: true,
        path: "/newdash/roles",
        name: "Users",
        state: "openTables",
        icon: GroupIcon,
        views: [
            {
                path: "/newdash/roles/user",
                name: "View Users",
                mini: "VU",
                component: UserRoles
            },
            // {
            //     path: "/roles/clinic",
            //     name: "View Roles",
            //     mini: "VR",
            //     component: ClinicRoles
            // }
        ]
    },
    /*isHealthSpaceUser() ? {

        path: "/newdash/support",
        name: "Support",
        icon: Person,
        component: Support,
    } : null,*/
    /*{
     path: "/newdash/patients",
     name: "Patients",
     icon: Person,
     component: Patients
     },*/
    // {
    //   path: "/newdash/addClinicMaster",
    //   name: "Add ClinicMaster",
    //   component: addClinicMaster,
    //   invisible: true
    // },
    // {
    //   path: "/newdash/readOneClinicMaster",
    //   name: "Clinic Master View",
    //   component: oneClinicMaster,
    //   invisible: true
    // },
    // {
    //   path: "/newdash/updateClinicMaster",
    //   name: "Update ClinicMaster",
    //   component: updateClinicMaster,
    //   invisible: true
    // },
    mappingUI(Permissions.AddMaster) ?
        {
            path: "/newdash/clinicmaster/add",
            name: "Add ClinicMaster",
            component: addClinicMaster,
            invisible: true
        } : null,
    mappingUI(Permissions.ViewMaster) ?

        {
            path: "/newdash/clinicmaster/oneClinicMaster/:clinicmasterID",
            name: "Clinic Master View",
            component: oneClinicMaster,
            invisible: true
        } : null,
    mappingUI(Permissions.UpdateMaster) ?
        {
            path: "/newdash/clinicmaster/updateClinicMaster/:clinicmasterID",
            name: "Update ClinicMaster",
            component: updateClinicMaster,
            invisible: true
        } : null,
    mappingUI(Permissions.AddClinic) ?
        {
            path: "/newdash/clinic/addClinic/:clinicmasterID",
            name: "Add Clinic",
            icon: WidgetsIcon,
            component: addClinic,
            invisible: true
        } : null,
    mappingUI(Permissions.AddClinic) ?
        {
            path: "/newdash/clinic/addClinic",
            name: "Add Clinic",
            icon: WidgetsIcon,
            component: addClinic,
            invisible: true
        } : null,
    mappingUI(Permissions.UpdateClinic) ?
        {
            path: "/newdash/clinic/updateClinic/:clinicID",
            name: "Update Clinic",
            icon: WidgetsIcon,
            component: updateClinic,
            invisible: true
        } : null,
    mappingUI(Permissions.ViewClinic) ?
        {
            path: "/newdash/clinic/oneClinic/:clinicID",
            name: "Clinic View",
            icon: WidgetsIcon,
            component: oneClinic,
            invisible: true
        } : null,
    mappingUI(Permissions.AddPatient) ?
        {
            path: "/newdash/patient/addPatient",
            name: "Add Patient",
            icon: WidgetsIcon,
            component: addPatient,
            invisible: true
        } : null,
    mappingUI(Permissions.UpdatePatient) ?

        {
            path: "/newdash/patient/updatePatient/:patientID",
            name: "Update Patient",
            icon: WidgetsIcon,
            component: updatePatient,
            invisible: true
        } : null,
    mappingUI(Permissions.ViewPatient) ?
        {
            path: "/newdash/patient/:patientID",
            name: "One Patient",
            icon: WidgetsIcon,
            component: onePatient,
            invisible: true
        } : null,
    mappingUI(Permissions.AddDoctor) ?

        {
            path: "/newdash/doctor/addDoctor/:clinicmasterID/:clinicID",
            name: "Add Doctor",
            icon: WidgetsIcon,
            component: addDoctor,
            invisible: true
        } : null,
    mappingUI(Permissions.AddDoctor) ?
        {
            path: "/newdash/doctor/addDoctor",
            name: "Add Doctor",
            icon: WidgetsIcon,
            component: addDoctor,
            invisible: true
        } : null,
    mappingUI(Permissions.ViewDoctor) ?
        {
            path: "/newdash/doctor/oneDoctor/:doctorID",
            name: "One Doctor",
            icon: WidgetsIcon,
            component: oneDoctor,
            invisible: true
        } : null,
    mappingUI(Permissions.UpdateDoctor) ?
        {
            path: "/newdash/doctor/updateDoctorDetails/:doctorID/:clinicID",
            name: "Update Doctor",
            icon: WidgetsIcon,
            component: updateDoctorTS,
            invisible: true
        } : null,
    mappingUI(Permissions.UpdateDoctor) ?
        {
            path: "/newdash/doctor/updateDoctorDetails/:doctorID",
            name: "Update Doctor",
            icon: WidgetsIcon,
            component: updateDoctorTS,
            invisible: true
        } : null,
    mappingUI(Permissions.UpdateDoctor) ?
        {
            path: "/newdash/doctor/updateDoctorClinic",
            name: "Update Doctor",
            icon: WidgetsIcon,
            component: updateDoctorTS,
            invisible: true
        } : null,
    {
        path: "/newdash/clinic/role/view/:id",
        name: "Clinic Master",
        icon: WidgetsIcon,
        component: ClinicRoleView,
        invisible: true
    },
    mappingUI(Permissions.AddUser) ?
        {
            path: "/newdash/user/role/add",
            name: "User Role Add",
            icon: WidgetsIcon,
            component: UserRoleAdd,
            invisible: true
        } : null,
    mappingUI(Permissions.ViewUsers) ?
        {
            path: "/newdash/user/role/clinicmaster/:clinicMasterID/:id",
            name: "User Role View",
            icon: WidgetsIcon,
            component: UserRoleView,
            invisible: true
        } : null,
    mappingUI(Permissions.UpdateUser) ?
        {
            path: "/newdash/user/role/update/clinicmaster/:clinicMasterID/:id",
            name: "User Role View",
            icon: WidgetsIcon,
            component: UserRoleUpdate,
            invisible: true
        } : null,
    mappingUI(Permissions.AddRole) ?
        {
            path: "/newdash/clinic/role/add",
            name: "Clinic Role Add",
            icon: WidgetsIcon,
            component: ClinicRoleAdd,
            invisible: true
        } : null,
    mappingUI(Permissions.UpdateRole) ?

        {
            path: "/newdash/clinic/role/update/:clinicMasterID/:id",
            name: "Clinic Role Update",
            icon: WidgetsIcon,
            component: ClinicRoleUpdate,
            invisible: true
        } : null,
    mappingUI(Permissions.AddAppointment) ?
        {
            path: "/newdash/appointment/bookAppointment/:patientID",
            name: "Book Appointment",
            icon: WidgetsIcon,
            component: BookAppointment,
            invisible: true
        } : null,
    mappingUI(Permissions.AddAppointment) ?
        {
            path: "/newdash/appointment/bookAppointment",
            name: "Book Appointment",
            icon: WidgetsIcon,
            component: BookAppointment,
            invisible: true
        } : null,
    {
        path: "/newdash/appointment/book/schedule/:DateTime",
        name: "Book Appointment",
        icon: WidgetsIcon,
        component: BookAppointment,
        invisible: true
    },
    {
        path: "/newdash/appointment/request/view/:id",
        name: "Add Report",
        icon: WidgetsIcon,
        component: OneAppointmentRequest,
        invisible: true
    },
    {
        path: "/newdash/appointment/view/:id",
        name: "Add Report",
        icon: WidgetsIcon,
        component: OneAppointment,
        invisible: true
    },
    {
        path: "/newdash/appointment/update/:id",
        name: "Add Report",
        icon: WidgetsIcon,
        component: UpdateAppointment,
        invisible: true
    },
    {
        path: "/newdash/appointment/calendar",
        name: "Appointment Calendar",
        icon: WidgetsIcon,
        component: AppointmentCalendar,
        invisible: true
    },
    mappingUI(Permissions.UploadReports) ?
        {
            path: "/newdash/report/add/:patientID",
            name: "Add Report",
            icon: WidgetsIcon,
            component: AddReports,
            invisible: true
        } : null,
    mappingUI(Permissions.UploadReports) ?
        {
            path: "/newdash/report/add",
            name: "Add Report",
            icon: WidgetsIcon,
            component: AddReports,
            invisible: true
        } : null,
    mappingUI(Permissions.UploadReports) ?
        {
            path: "/newdash/report/adddrag",
            name: "Add Report",
            icon: WidgetsIcon,
            component: AddReportsDrag,
            invisible: true
        } : null,
    mappingUI(Permissions.ViewReports) ?
        {
            path: "/newdash/report/view/:id",
            name: "Add Report",
            icon: WidgetsIcon,
            component: OneReport,
            invisible: true
        } : null,
    mappingUI(Permissions.UpdateReports) ?
        {
            path: "/newdash/report/update/:id",
            name: "Add Report",
            icon: WidgetsIcon,
            component: UpdateReports,
            invisible: true
        } : null,
    {
        path: "/newdash/myprofile",
        name: "My Profile",
        icon: WidgetsIcon,
        component: ViewProfile,
        invisible: true
    },
    {
        path: "/newdash/appointment/request/view/:id",
        name: "View Appointment Request",
        icon: WidgetsIcon,
        component: OneAppointmentRequest,
        invisible: true
    }, {
        path: "/newdash/package/request/view/:id",
        name: "View Package Request",
        icon: WidgetsIcon,
        component: OnePackageRequest,
        invisible: true
    }, {
        path: "/newdash/test/request/view/:id",
        name: "View Test Request",
        icon: WidgetsIcon,
        component: OneTestRequest,
        invisible: true
    },
    {
        path: "/newdash/marketing/recampaign/:id",
        name: "Re-Campaign",
        mini: "RC",
        component: ReCampaign,
        invisible: true
    },
    {
        path: "/newdash/marketing/campaign",
        name: "Campaign",
        icon: WidgetsIcon,
        component: Campaign,
        invisible: true

    },
    // { path: "/newdash/charts", name: "Charts", icon: Timeline, component: Charts },
    // { path: "/newdash/calendar", name: "Calendar", icon: DateRange, component: Calendar },
    {redirect: true, path: "/newdash", pathTo: "/newdash/dashboard", name: "Dashboard"}
];
export default newDashRoutes;



// WEBPACK FOOTER //
// ./src/routes/newdash.jsx